const colors = {
  white: '#FFFFFF',
  black: '#000000',
  cyan: {
    100: '#C4E6F9',
  },
  grey: {
    200: '#F1F1F1',
    300: '#ECECEC',
  },
  neutral: {
    black: '#333333',
  },
  orange: {
    100: '#FFE1C0',
  },
  purple: {
    100: '#E0D7EB',
  },
  coolGrey: {
    100: '#003349',
  },
  systemLink: '#644B9F',
};

export default colors;
